export { PickerIconsEnum } from '../components/IconPicker/constants';

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum POST_MESSAGES {
  NAVIGATE_TO_APPLICATION_PORTAL = 'NAVIGATE_TO_APPLICATION_PORTAL',
  NAVIGATE_TO_SELF_SECHEDULE_MAKE_CHANGES = 'NAVIGATE_TO_SELF_SECHEDULE_MAKE_CHANGES',
  APPLICATION_LOADED = 'APPLICATION_LOADED',
  NAVIGATE_BACK = 'NAVIGATE_BACK',
}

export const MAX_WIDTH_PORTAL_CONTENT = '1140px';

export { SupportedFonts } from './Fonts';

export const MAX_PROFILE_IMAGE_SIZE = 5 * 1000 * 1000; // 5 mb

export const EMAIL_REGEX = /^[^@\s+]+(?:\+[^@\s]*)?@[^@\s+]+\.[^@\s+]+$/;

// Order is important here, as it determines the order of the ratings in the dropdown
// Emoji -> value is 1-5
export const CANDIDATE_PULSE_SURVEY_EMOJI_RANKINGS = ['😠', '🙁', '😐', '🙂', '🤩'];

export const DATADOG_TRACE_ID_HEADER = 'X-Datadog-Trace-Id';

// ID in menu items to identify a divider
export const DIVIDER_ID = 'divider';
